import { ReactElement, useMemo } from 'react'
import {
    Button,
    Grid,
    SVG,
    SVGs,
    ServiceCard,
    Skeleton,
} from '@raskrask-dk/rr-components'
import { CustomerTypeButtons, Props } from '.'
import { t } from 'i18next'

const CustomerTypeCardsTemplate = ({
    customerType,
    customerTypes,
    isLoading,
    onCustomerTypeClick,
}: Props): ReactElement => {
    const loading = useMemo(
        () => (
            <>
                <Skeleton height={36} width={100} />
                <Skeleton height={36} width={100} />
            </>
        ),
        []
    )

    const customerTypeCards = useMemo(
        () =>
            customerTypes.map((type, key) => (
                <ServiceCard
                    buttonText={t('common:choose')}
                    data-cy={`CustomerType_${key + 1}`}
                    icon={
                        <SVG
                            src={type === 'Company' ? SVGs.Office : SVGs.House}
                            css={{
                                height: '2.5rem',
                                margin: 'auto',
                                display: 'block',

                                '@desktop': {
                                    height: '4rem',
                                },
                            }}
                        />
                    }
                    key={key}
                    name={t(`basistypes.customertypes.${type}`)}
                    onClick={() => onCustomerTypeClick(type)}
                />
            )),
        [customerTypes, onCustomerTypeClick]
    )

    return (
        <CustomerTypeButtons>
            <Grid
                autoFlow={{
                    '@mobile': 'row',
                    '@desktop': 'dense',
                }}
                gap={{ '@mobile': 16, '@desktop': 32 }}
            >
                {isLoading ? loading : customerTypeCards}
            </Grid>
        </CustomerTypeButtons>
    )
}

export default CustomerTypeCardsTemplate
